const jsonify = (json) => JSON.parse(json);

// ✅ Firebase Functions로 저장 요청만 보냄
async function UpdateSheets() {
  const userType = Number(localStorage.getItem("userType")) - 1;
  const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
  const userAnswer = JSON.parse(localStorage.getItem("userAnswer") || "{}");

  const key1 = jsonify(process.env.REACT_APP_KEY1)[userType];
  const key2 = process.env.REACT_APP_KEY2;
  const key3 = jsonify(process.env.REACT_APP_KEY3)[userType];
  const key4 = jsonify(process.env.REACT_APP_KEY4)[userType];

  const value1 = jsonify(process.env.REACT_APP_VALUE1)[userType][userInfo["0"]];
  const value2 = jsonify(process.env.REACT_APP_VALUE2)[userInfo["1"]];
  const value3 = jsonify(process.env.REACT_APP_VALUE3)[userType][userInfo["2"]];
  const value4 = jsonify(process.env.REACT_APP_VALUE4)[userType][userInfo["3"]];

  Object.keys(userAnswer).forEach((v) => {
    userAnswer[v] = jsonify(process.env.REACT_APP_ANSWERS)[userAnswer[v]];
  });

  const row = {
    [key1]: value1,
    [key2]: value2,
    [key3]: value3,
    [key4]: value4,
    ...userAnswer,
  };

  // ✅ Functions URL (배포 후 실제 URL로 교체)
  const url = process.env.REACT_APP_FUNCTIONS_UPDATE_SHEETS_URL;
  if (!url) throw new Error("Missing REACT_APP_FUNCTIONS_UPDATE_SHEETS_URL");

  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ userType, row }),
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data?.error || "Failed to update sheets");
  return data;
}

export default UpdateSheets;
